module.exports = __webpack_public_path__ + "static/media/bruno 1.5e7ddf95.svg";